export default __webpack_public_path__ + "static/laura-d729ca049964706575d6668bdcf09d5c.mp4";